import useOpenApiClient from '@/hooks/useOpenApiClient';
import { cn, ColoredTileIndex, coloredTileVariants } from '@/lib/utils';
import { components } from '@/types/api';
import { useQuery } from '@tanstack/react-query';
import { Fragment, useCallback } from 'react';

export default function EnrichedBlock({
  benefitTotals,
}: {
  benefitTotals: components['schemas']['ReceiptOutput']['benefit_totals'];
}) {
  const { apiFetch } = useOpenApiClient();
  const accountsQuery = useQuery({
    queryKey: ['v1', 'accounts'],
    queryFn: () => apiFetch.GET('/accounts'),
    select: (data) => data.data?.data,
  });

  const getAccountIndex = useCallback(
    (accountId: string, index: number) => {
      const idx = accountsQuery.data?.findIndex((account) => account.id === accountId);
      return idx && idx !== -1 ? idx : index;
    },
    [accountsQuery.data],
  );

  return (
    <div className="px-4 pt-3">
      <div className="space-y-2">
        {benefitTotals?.map((benefit, index) => (
          <Fragment key={benefit.account_id}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1 py-1">
                <p
                  className={cn(
                    'p-1.8 bg-secondary-light flex h-4 w-4 items-center justify-center rounded-full',
                    coloredTileVariants({
                      index: (getAccountIndex(benefit.account_id, index) % 12) as ColoredTileIndex,
                    }),
                  )}
                >
                  <span className={`text-primary-dark text-xs`}>{benefit.account_name[0]}</span>
                </p>
                <span className="text-xs font-normal capitalize">{benefit.account_name}</span>
              </div>
              <span className="text-primary text-xs font-bold">${benefit.total}</span>
            </div>
            {benefitTotals.length - 1 !== index && (
              <div className="border-background border-b"></div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
